import React, { useEffect, useState, useContext } from "react";
import {
  BrowserRouter,
  Switch,
  // Route puro: a vitrine publica NAO pode passar pelo Route
  // customizado, que redireciona usuario logado para o painel.
  Route as PublicRoute
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import moment from "moment";

import LoggedInLayout from "../layout";
import Dashboard from "../pages/Dashboard/";
import TicketResponsiveContainer from "../pages/TicketResponsiveContainer";
import Signup from "../pages/Signup";
import Login from "../pages/Login/";
import Legal from "../pages/Legal";
import EsqueceuSenha from "../pages/EsqueceuSenha";
import RedefinirSenha from "../pages/RedefinirSenha";
import Connections from "../pages/Connections/";
import Settings from "../pages/SettingsCustom/";
import Financeiro from "../pages/Financeiro/";
import Users from "../pages/Users";
import Contacts from "../pages/Contacts/";
import Groups from "../pages/Groups/";
import ContactImportPage from "../pages/Contacts/import";
import ChatMoments from "../pages/Moments";
import Queues from "../pages/Queues/";
import Tags from "../pages/Tags/";
import MessagesAPI from "../pages/MessagesAPI/";
import Helps from "../pages/Helps/";
import ContactLists from "../pages/ContactLists/";
import ContactListItems from "../pages/ContactListItems/";
import Companies from "../pages/Companies/";
import Wallets from "../pages/Wallets/";
import QuickMessages from "../pages/QuickMessages/";
import { AuthProvider, AuthContext } from "../context/Auth/AuthContext";
import { TicketsContextProvider } from "../context/Tickets/TicketsContext";
import { WhatsAppsProvider } from "../context/WhatsApp/WhatsAppsContext";
import Route from "./Route";
import { LegacySchedules } from "../pages/UnifiedAgenda";
import Campaigns from "../pages/Campaigns";
import CampaignsConfig from "../pages/CampaignsConfig";
import CampaignReport from "../pages/CampaignReport";
import Annoucements from "../pages/Annoucements";
import Chat from "../pages/Chat";
import Prompts from "../pages/Prompts";
import AIAgentPage from "../pages/AIAgent";
import AllConnections from "../pages/AllConnections/";
import RelatorioVendas from "../pages/RelatorioVendas";
import Subscription from "../pages/Subscription/";
import QueueIntegration from "../pages/QueueIntegration";
import Files from "../pages/Files/";
import ToDoList from "../pages/ToDoList/";
import Kanban from "../pages/Kanban";
import TagsKanban from "../pages/TagsKanban";
import BirthdaySettingsPage from "../pages/BirthdaySettings";
import Charges from "../pages/Charges/";
import ProdutosServicos from "../pages/ProdutosServicos/";
import RelatorioProdutos from "../pages/RelatorioProdutos/";
import Loja from "../pages/Loja/";
import LojaConfig from "../pages/LojaConfig/";
import UnifiedAgenda from "../pages/UnifiedAgenda/";
import MetaCapiConfig from "../pages/MetaCapiConfig/";
import ConectarPublico from "../pages/ConectarPublico/";
import LigarPublico from "../pages/LigarPublico/";
import RecursoIndisponivel from "../pages/RecursoIndisponivel/";
import Affiliates from "../pages/Affiliates/";
import Supervisors from "../pages/Supervisors/";
import Finance from "../pages/Finance/";
import AffiliatePanel from "../pages/AffiliatePanel/";
import Management from "../pages/Management/";

import { FlowBuilderConfig } from "../pages/FlowBuilderConfig";
import FlowBuilder from "../pages/FlowBuilder";
import FlowDefault from "../pages/FlowDefault";
import CampaignsPhrase from "../pages/CampaignsPhrase";
import Floup from "../pages/Floup";
import FloupDashboard from "../pages/FloupDashboard";
import TemplateManager from "../pages/TemplateManager";

const RoutesContent = () => {
  const [showCampaigns, setShowCampaigns] = useState(false);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    const cshow = localStorage.getItem("cshow");
    if (cshow !== undefined) {
      setShowCampaigns(true);
    }
  }, []);

  // Verificar se a empresa está vencida
  const isCompanyExpired = () => {
    if (!user || !user.company || user.company.id === 1) {
      return false; // Empresa ID 1 nunca expira
    }

    const dueDate = user.company.dueDate;
    if (!dueDate) return false;

    // Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
    const hojeInicio = moment().startOf('day');
    const vencimentoInicio = moment(dueDate).startOf('day');

    // Empresa está vencida apenas após o dia do vencimento
    return hojeInicio.isAfter(vencimentoInicio, 'day');
  };

  if (user?.isAffiliate) {
    return (
      <>
        <Switch>
          <Route exact path="/login" component={Login} />
          <PublicRoute exact path="/politica-de-privacidade" render={() => <Legal type="privacy" />} />
          <PublicRoute exact path="/termos-de-uso" render={() => <Legal type="terms" />} />
          <Route path="/" component={AffiliatePanel} isPrivate />
        </Switch>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          style={{ zIndex: 20000 }}
        />
      </>
    );
  }

  return (
    <TicketsContextProvider>
      <Switch>
        <Route exact path="/login" component={Login} />
        <PublicRoute exact path="/politica-de-privacidade" render={() => <Legal type="privacy" />} />
        <PublicRoute exact path="/termos-de-uso" render={() => <Legal type="terms" />} />
        {/* Vitrine publica: Route puro do react-router, NAO o Route
            customizado — ele redireciona usuario logado para o painel
            ("if (isAuth && !isPrivate)"), e o dono da loja precisa
            conseguir abrir a propria loja estando logado. */}
        <PublicRoute exact path="/loja/:slug" component={Loja} />
        <PublicRoute exact path="/conectar/:token" component={ConectarPublico} />
        <PublicRoute exact path="/call/:token" component={LigarPublico} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/esqueceu-senha" component={EsqueceuSenha} />
        <Route exact path="/redefinir-senha" component={RedefinirSenha} />
        <WhatsAppsProvider>
          <LoggedInLayout hideMenu={isCompanyExpired()}>
            <Route
              exact
              path="/financeiro"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/financeiro-aberto"
              component={Financeiro}
              isPrivate
            />

            <Route
              exact
              path="/companies"
              component={Companies}
              isPrivate
            />
            <Route
              exact
              path="/birthday-settings"
              component={BirthdaySettingsPage}
              isPrivate
            />
            <Route exact path="/charges" component={Charges} isPrivate />
            <Route exact path="/recurso-indisponivel" component={RecursoIndisponivel} isPrivate />
            <Route
              exact
              path="/produtos-servicos"
              component={ProdutosServicos}
              isPrivate
            />
            <Route
              exact
              path="/relatorio-produtos"
              component={RelatorioProdutos}
              isPrivate
            />
            <Route
              exact
              path="/loja-config"
              component={LojaConfig}
              isPrivate
            />
            <Route
              exact
              path="/agenda"
              component={UnifiedAgenda}
              isPrivate
            />
            <Route
              exact
              path="/integracao-meta"
              component={MetaCapiConfig}
              isPrivate
            />
            <Route exact path="/finance" component={Finance} isPrivate />
            <Route exact path="/affiliates" component={Affiliates} isPrivate />
            <Route exact path="/supervisors" component={Supervisors} isPrivate />
            <Route exact path="/management" component={Management} isPrivate />
            <Route exact path="/dashboard" component={Dashboard} isPrivate />
            <Route exact path="/" component={Dashboard} isPrivate />

            <Route
              exact
              path="/tickets/:ticketId?"
              component={TicketResponsiveContainer}
              isPrivate
            />
            <Route
              exact
              path="/connections"
              component={Connections}
              isPrivate
            />
            <Route
              exact
              path="/quick-messages"
              component={QuickMessages}
              isPrivate
            />
            <Route
              exact
              path="/template-manager"
              component={TemplateManager}
              isPrivate
            />
            <Route exact path="/todolist" component={ToDoList} isPrivate />
            <Route
              exact
              path="/schedules"
              component={LegacySchedules}
              isPrivate
            />
            <Route exact path="/tags" component={Tags} isPrivate />
            <Route exact path="/contacts" component={Contacts} isPrivate />
            <Route exact path="/groups" component={Groups} isPrivate />
            <Route
              exact
              path="/contacts/import"
              component={ContactImportPage}
              isPrivate
            />
            <Route exact path="/wallets" component={Wallets} isPrivate />
            <Route exact path="/helps" component={Helps} isPrivate />
            <Route exact path="/users" component={Users} isPrivate />
            <Route
              exact
              path="/messages-api"
              component={MessagesAPI}
              isPrivate
            />
            <Route
              exact
              path="/settings"
              component={Settings}
              isPrivate
            />
            <Route exact path="/queues" component={Queues} isPrivate />
            <Route
              exact
              path="/relatorio-vendas"
              component={RelatorioVendas}
              isPrivate
            />
            <Route
              exact
              path="/queue-integration"
              component={QueueIntegration}
              isPrivate
            />
            <Route
              exact
              path="/announcements"
              component={Annoucements}
              isPrivate
            />
            <Route exact path="/chats/:id?" component={Chat} isPrivate />
            <Route exact path="/files" component={Files} isPrivate />
            <Route
              exact
              path="/moments"
              component={ChatMoments}
              isPrivate
            />
            <Route exact path="/Kanban" component={Kanban} isPrivate />
            <Route
              exact
              path="/TagsKanban"
              component={TagsKanban}
              isPrivate
            />
            <Route exact path="/prompts" component={Prompts} isPrivate />
            <Route exact path="/ai-agents" component={AIAgentPage} isPrivate />
            <Route
              exact
              path="/allConnections"
              component={AllConnections}
              isPrivate
            />

            <Route
              exact
              path="/plugins/floup"
              component={Floup}
              isPrivate
            />
            <Route
              exact
              path="/plugins/floup/dashboard"
              component={FloupDashboard}
              isPrivate
            />

            <Route
              exact
              path="/phrase-lists"
              component={CampaignsPhrase}
              isPrivate
            />
            <Route
              exact
              path="/flowbuilders"
              component={FlowBuilder}
              isPrivate
            />
            <Route
              exact
              path="/flowbuilder/:id?"
              component={FlowBuilderConfig}
              isPrivate
            />

            {showCampaigns && (
              <>
                <Route
                  exact
                  path="/campaigns"
                  component={Campaigns}
                  isPrivate
                />
                <Route
                  exact
                  path="/campaign/:campaignId/report"
                  component={CampaignReport}
                  isPrivate
                />
              </>
            )}
          </LoggedInLayout>
        </WhatsAppsProvider>
      </Switch>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        style={{ zIndex: 20000 }}
      />
    </TicketsContextProvider>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <RoutesContent />
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
